"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_redux_1 = require("react-redux");
var CWSSearchMap_1 = require("../components/CWSSearchMap");
var reactstrap_1 = require("reactstrap");
var CWSRateSearch_1 = require("../components/CWSRateSearch");
var RateSearchStore = require("../store/RateSearch");
var CWSSearch = /** @class */ (function (_super) {
    __extends(CWSSearch, _super);
    function CWSSearch() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    //state = {
    //    isCountySelectionOpen: false,
    //    isRateSearchOpen: false
    //};
    //private toggleCountySelection(e: any) {
    //    e.preventDefault();
    //    this.setState({ isCountySelectionOpen: !this.state.isCountySelectionOpen, isRateSearchOpen: (this.state.isCountySelectionOpen) ? false : this.state.isRateSearchOpen});
    //}
    CWSSearch.prototype.render = function () {
        return (React.createElement(React.Fragment, null,
            React.createElement(reactstrap_1.Collapse, { isOpen: (this.props.countyId == undefined || this.props.countyId == 0) },
                React.createElement(reactstrap_1.Card, null,
                    React.createElement(reactstrap_1.CardBody, null,
                        React.createElement("div", { className: "row" },
                            React.createElement("div", { className: "col-md-12", style: { paddingBottom: "10px" } },
                                React.createElement("h4", null, "Instructions"),
                                React.createElement("div", null, "Click on a county to view Plans and Rates available in your area. "))),
                        React.createElement("div", { className: "row" },
                            React.createElement("div", { className: "col-md-12 text-center" },
                                React.createElement(CWSSearchMap_1.default, null))),
                    React.createElement("div", { className: "row" },
                        React.createElement("div", { className: "col-md-12", style: { paddingTop: "10px" } },
                            React.createElement("span", { style: { fontWeight: 'bold' } }, "NOTE:"),
                            React.createElement("span", { style: { marginLeft: '10px' } }, "THIS IS BEING PROVIDED FOR COMPARISON PURPOSES ONLY TO DEMONSTRATE THE IMPORTANCE OF SHOPPING FOR INSURANCE QUOTES.")))),
                )),
            React.createElement("br", null),
            React.createElement(reactstrap_1.Collapse, { isOpen: this.props.countyId !== undefined && this.props.countyId > 0 },
                React.createElement(reactstrap_1.Card, null,
                    React.createElement(reactstrap_1.CardBody, null,
                        React.createElement(CWSRateSearch_1.default, null))))));
    };
    return CWSSearch;
}(React.PureComponent));
;
exports.default = react_redux_1.connect(function (state) { return state.rateSearch; }, RateSearchStore.actionCreators)(CWSSearch);
//# sourceMappingURL=CWSSearch.js.map